<template>
  <div>
    <b-modal
      id="modal-input-koordinator"
      size="xl"
      centered
      title="Tambah Data Koordinator"
      header-bg-variant="primary"
      header-text-variant="light"
    >
      <b-form>
        <b-form-group label="Nama Koordinator" label-cols-md="3">
          <b-form-input
            autofocus
            type="text"
            :state="checkIfValid('namaKoordinator')"
            v-model="$v.data.namaKoordinator.$model"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Kode Koordinator" label-cols-md="3">
          <b-form-input
            type="text"
            :state="checkIfValid('kodeKoordinator')"
            v-model="$v.data.kodeKoordinator.$model"
          ></b-form-input>
        </b-form-group>
        <!-- <b-form-group v-if="isSuper" label="Nama Mitra" label-cols-md="3">
          <multiselect
            v-model="$v.data.mitra.$model"
            :state="checkIfValid('mitra')"
            :options="mitra"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaMitra"
            placeholder="-- Pilih --"
          ></multiselect>
        </b-form-group> -->
        <b-form-group label="Provinsi" label-cols-md="3">
          <multiselect
            v-model="$v.data.provinsi.$model"
            :state="checkIfValid('provinsi')"
            :options="provinsi"
            @input="getKota(data.provinsi)"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            label="namaProvinsi"
            track-by="id"
            placeholder="-- Pilih Provinsi --"
          ></multiselect>
        </b-form-group>

        <b-form-group label="Kota" label-cols-md="3">
          <multiselect
            v-model="$v.data.kota.$model"
            :state="checkIfValid('kota')"
            :options="kota"
            @input="getKecamatan(data.kota)"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaKota"
            track-by="idKota"
            placeholder="-- Pilih Kabupaten/Kota --"
          ></multiselect>
        </b-form-group>

        <b-form-group label="Kecamatan" label-cols-md="3">
          <multiselect
            v-model="$v.data.kecamatan.$model"
            :state="checkIfValid('kecamatan')"
            :options="kec"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaKecamatan"
            track-by="kecamatanId"
            placeholder="-- Pilih Kecamatan --"
          ></multiselect>
        </b-form-group>
        <b-form-group label="Alamat" label-cols-md="3">
          <b-form-input
            type="text"
            :state="checkIfValid('alamatKoordinator')"
            v-model="$v.data.alamatKoordinator.$model"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="No. Telp" label-cols-md="3">
          <b-form-input
            type="number"
            :state="checkIfValid('noHpKantor')"
            v-model="$v.data.noHpKantor.$model"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Latitude" label-cols-md="3">
          <b-form-input
            type="text"
            :state="checkIfValid('latitude')"
            v-model="$v.data.latitude.$model"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Longtitude" label-cols-md="3">
          <b-form-input
            type="text"
            :state="checkIfValid('longitude')"
            v-model="$v.data.longitude.$model"
          ></b-form-input>
        </b-form-group>
      </b-form>
      <!-- <img :src="src1" /> -->
      <template #modal-footer>
        <b-button
          variant="secondary"
          @click="$bvModal.hide('modal-input-koordinator')"
        >
          Tutup
        </b-button>
        <b-button
          variant="primary"
          :disabled="busy || !isValid"
          @click="simpan()"
        >
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
export default {
  components: { Multiselect },
  props: ["mitra", "provinsi"],
  data() {
    return {
      data: {
        namaKoordinator: "",
        kodeKoordinator: "",
        mitra: "",
        provinsi: "",
        kota: "",
        kecamatan: "",
        alamatKoordinator: "",
        noHpKantor: "",
        longitude: 0,
        latitude: 0,
      },
      kota: [],
      kec: [],
      busy: false,
      button: "Simpan",
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.data, null, 4);
    },
    isValid() {
      return !this.$v.data.$invalid;
    },
    isDirty() {
      return this.$v.data.$anyDirty;
    },
    isSuper() {
      return this.$store.state.role_aktif.kodeRole == 'super';
    },
  },
  mixins: [validationMixin],
  validations: {
    data: {
      // mitra: {
      //   required,
      // },
      provinsi: {
        required,
      },
      kota: {
        required,
      },
      kecamatan: {
        required,
      },
      namaKoordinator: {
        required,
      },
      kodeKoordinator: {
        required,
      },
      alamatKoordinator: {
        required,
      },
      noHpKantor: {
        required,
      },
      longitude: {
        required,
      },
      latitude: {
        required,
      },
    },
  },
  async mounted() {
    const vm = this
    const mitra = vm.$store.state.mitra_aktif
    if(mitra) vm.data.mitra = mitra
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    async getKota(x) {
      let kota = await this.$axios.get("kota/listByProvinsiId/" + x.id);
      // console.log(kota.data.data);
      this.kota = kota.data.data;
    },
    async getKecamatan(x) {
      let kec = await this.$axios.get("kecamatan/listByKotaId/" + x.idKota
      );
      // console.log(kec.data.data);
      this.kec = kec.data.data.map(x=>{
        return{
          ...x,
          id: x.kecamatanId,
        }
      });
      
    },
    simpan() {
      let vm = this;
      vm.data.mitraId = vm.data.mitra.id;
      vm.data.provinsiId = vm.data.provinsi.id;
      vm.data.kotaId = vm.data.kota.idKota;
      vm.data.kecamatanId = vm.data.kecamatan.kecamatanId;
      vm.$axios
        .post("koordinator/register", vm.data)
        .then((res) => {
          if (res.data.message == "sukses") {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "success",
              msg: "BERHASIL MENDAFTARKAN KOORDINATOR",
              showing: true,
            });
            this.data.namaKoordinator = "";
            this.data.kodeKoordinator = "";
            this.data.alamatKoordinator = "";
            this.data.noHpKantor = "";
            this.$v.$reset();
            this.$bvModal.hide("modal-input-koordinator");
          } else {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: _.toUpper(res.data.message),
              showing: true,
            });
          }
        })
        .catch(() => {
          vm.button = "Simpan";
          vm.busy = false;
          vm.$emit("alertFromChild", {
            variant: "danger",
            msg: "TERJADI KESALAHAN PADA SERVER",
            showing: true,
          });
        });
    },
  },
};
</script>
